import { Collection } from 'modules/core/lib/mobx-rest'

import PayrollDocument from 'modules/payroll_bundle/store/models/PayrollDocument'

class PayrollDocuments extends Collection<PayrollDocument> {
  get cacheKey(): string {
    return 'payrollDocuments'
  }

  model() {
    return PayrollDocument
  }
}

export { PayrollDocuments }
